import { Injectable } from '@angular/core'
import { generateCssVariables, APP_COLORS } from '@styles/theme-colors'

@Injectable({
    providedIn: 'root'
})
export class ThemeService {
    constructor() {
        this.initializeTheme();
    }
    /**
     * Initialize the theme by injecting CSS variables into the document
     */
    private initializeTheme(): void {
        const styleElement = document.createElement('style');
        styleElement.textContent = generateCssVariables();
        document.head.appendChild(styleElement);
    }

    /**
     * Get a specific color by its key
     */
    getColor(colorKey: keyof typeof APP_COLORS): string {
        return APP_COLORS[colorKey];
    }
}
